var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"passport-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center text-white"},[_c('small',[_vm._v("© Copyright 2019 lisaoma.cn. All rights reserved.")])])])])
}]

export { render, staticRenderFns }